import React from 'react';
import Iframe from 'react-iframe';
import { IframeVideoWrapper } from '../element';

const EmbeddedPlayer = (props) => {
  return (
    <IframeVideoWrapper
      url={props.url}
      page={props.page}
      data-test-id={props.id + '-wrapper'}
    >
      <Iframe url={props.url || ''} id={props.id} allowFullScreen />
    </IframeVideoWrapper>
  );
};

export default EmbeddedPlayer;
